import ChatOutlinedIcon from "@mui/icons-material/ChatOutlined";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import SavedSearchIcon from "@mui/icons-material/SavedSearch";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";

export const cartsData = [
  {
    id: 0,
    icon: ChatOutlinedIcon,
    text: "Exchange meaningful conversation",
  },
  {
    id: 1,
    icon: PersonOutlineIcon,
    text: "Singles revealing their true self through detailed profiles",
  },
  {
    id: 2,
    icon: SavedSearchIcon,
    text: "A powerful search tool with detailed filtration",
  },
  {
    id: 3,
    icon: CalendarMonthOutlinedIcon,
    text: "Themed events that create exciting dating occasions",
  },
];
